export default "__VITE_ASSET__28b98fd2__"